<template>
  <el-tabs v-model="internalActiveTab" @tab-click="handleClick">
    <el-tab-pane class="container-tabs-statistics" :label="$t('statisticsMeta.overview')" name="overview">
      <slot name="overview"></slot>
    </el-tab-pane>
    <el-tab-pane :label="$t('statisticsMeta.publicationReport')" name="publicationReport">
      <slot name="publicationReport"></slot>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { TabPane, Tabs } from 'element-ui'
export default {
  name: 'BasicTabs',
  props: ['networkName', 'tabActive'],
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data () {
    return {
      internalActiveTab: this.tabActive || 'overview'
    }
  },
  watch: {
    tabActive (newValue) {
      if (newValue !== this.internalActiveTab) {
        this.internalActiveTab = newValue || 'overview'
      }
    }
  },
  methods: {
    handleClick (tab, event) {
      const wouldLikeToSeePosts = (tab.name === 'publicationReport') ? 'posts' : null
      if (tab.name === 'overview') {
        this.$route.params.network = undefined
        this.$route.params.tabActive = undefined
        this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: null })
      }
      if (this.networkName !== 'linkedin' && wouldLikeToSeePosts === 'posts') {
        this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: wouldLikeToSeePosts })
      }
      this.$emit('tab-change', tab.name)
      this.$store.dispatch('statisticsMeta/loadStatistics')
    }
  },
  mounted () {
    if (this.networkName !== 'linkedin' && this.internalActiveTab === 'publicationReport') {
      this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: 'posts' })
    } else {
      this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: null })
    }
    this.$store.dispatch('statisticsMeta/loadStatistics')
  }
}
</script>
<style scoped>
.container-tabs-statistics {
  margin-top: 15px;
}
</style>
